import MarkerClusterer from '@googlemaps/markerclustererplus';

(function($) {

/*
*  new_map
*
*  This function will render a Google Map onto the selected jQuery element
*
*  @type	function
*  @date	8/11/2013
*  @since	4.3.0
*
*  @param	$el (jQuery element)
*  @return	n/a
*/

function new_map( $el ) {

	// vars
	var args = {
		zoom		: 13,
		center		: new google.maps.LatLng(48.460822, -123.369490),
		mapTypeId	: google.maps.MapTypeId.ROADMAP,
		gestureHandling: 'greedy',
		fullscreenControl: false,
		mapTypeControl: false,
		streetViewControl: false,
	};

	// create map
	var map = new google.maps.Map( $el[0], args);

	// add markers
	// $markers.each(function(){

	add_marker( map );
	
	// const drawingManager = new google.maps.drawing.DrawingManager({

	// 	drawingControl: true,
	// 	drawingControlOptions: {
	// 	position: google.maps.ControlPosition.TOP_CENTER,
	// 	drawingModes: [
	// 		google.maps.drawing.OverlayType.CIRCLE,
	// 		google.maps.drawing.OverlayType.POLYGON,
	// 		google.maps.drawing.OverlayType.RECTANGLE,
	// 	],
	// 	},
	// });
	// drawingManager.setMap( map );

	// });

	// center map
	//center_map( map );

	google.maps.event.addListener(map, 'idle', function(event) {
		var bounds = map.getBounds();

		var ne = bounds.getNorthEast();
		var neLat = ne.lat();
		var neLng = ne.lng();
		var sw = bounds.getSouthWest();
		var swLat = sw.lat();
		var swLng = sw.lng();
		//alert( neLng );
	});

	window.addEventListener('popstate', function () {
		markerCluster.setMap(null); 
		deleteMarkers();
		console.log('Adding new markers...');
		add_marker( map );
	});

	// return
	return map;
	

}

// Deletes all markers in the array by removing references to them.
function deleteMarkers() {
	for (let i = 0; i < markers.length; i++) {
		markers[i].setMap(null);
	  }
	markerCluster.setMap(null);
	markers = [];
}
  

/*
*  add_marker
*
*  This function will add a marker to the selected Google Map
*
*  @type	function
*  @date	8/11/2013
*  @since	4.3.0
*
*  @param	$marker (jQuery element)
*  @param	map (Google Map object)
*  @return	n/a
*/

function add_marker( map ) {
	if ( ~window.location.href.indexOf('featured') ) {
		var listType =  ' and (ListAgentMlsId eq \'4633\' or ListAgentMlsId eq \'4960\')';
		var mlsStatus = '(MlsStatus eq \'Active\' or MlsStatus eq \'Pending\')';
	} else {
		var listType = '';
		var mlsStatus = 'MlsStatus eq \'Active\'';
	}
	var urlParams = new URLSearchParams(window.location.search);
	var getMlsNum = urlParams.get('mls_num');
	if ( getMlsNum ) {
		var mlsNum = ' and ListingId eq \'' + getMlsNum + '\'';
	} else {
		var mlsNum = '';
	}
	var getBathrooms = urlParams.get('bath_min');
	if ( getBathrooms ) {
		var minBath = ' and BathroomsTotalInteger ge \'' + getBathrooms + '\'';
	} else {
		var minBath = '';
	}
	var getBedrooms = urlParams.get('bed_min');
	if ( getBedrooms ) {
		var minBed = ' and BedroomsTotal ge \'' + getBedrooms + '\'';
	} else {
		var minBed = '';
	}
	var getMinPrice = urlParams.get('price_min');
	if ( getMinPrice ) {
		var minPrice = ' and ListPrice ge \'' + getMinPrice + '\'';
	} else {
		var minPrice = '';
	}
	var getMaxPrice = urlParams.get('price_max');
	if ( getMaxPrice ) {
		var maxPrice = ' and ListPrice le \'' + getMaxPrice + '\'';
	} else {
		var maxPrice = '';
	}

	$.ajax({
		url: 'https://api.bridgedataoutput.com/api/v2/OData/viva/Property/replication?access_token=5d3573419210dc1f8cdcd42507af245d&$filter=' + mlsStatus + ' and OriginatingSystemName eq \'Victoria+Real+Estate+Board\'' + mlsNum + listType + minBath + minBed + minPrice + maxPrice + '&$select=Coordinates',
		contentType: 'application/json',
		success: function( data ) {
		
				//console.log(data.bundle);
				//var test = JSON.parse(data);
				//$('.acf-map').html('<p>' + data.bundle[0].Coordinates + '</p>');
			//});
			// var
			//var $markers = $el.find('.marker');

			
			//var post_positions = window.mapPositions;
			//var post_positions = data.bundle;
			// add a markers reference
  
			markers = [];

			// get postions from JSON data
			//var positions = data.bundle;

			for (var i = 0; i < data.value.length; i++) {
			//positions.forEach(position => {
				//var latlng = new google.maps.LatLng(position.lat, position.lng);
				//$('.acf-map').html('<p>' + data.bundle[0].Coordinates + '</p>');
				var coords = data.value[i].Coordinates;
				var listingKey = data.value[i].ListingKey;
			
				if ( coords ) {
					
					//console.log(coords);
					var latlng = new google.maps.LatLng(coords[1],coords[0]);

					// create marker
					var iconBase = '/wp-content/themes/windebank/assets/img/'
					var marker = new google.maps.Marker({
						position	: latlng,
						map			: map,
						icon        : iconBase + 'dfh-map-marker.png'
						//htmlContent : $marker.html()
					});

					var contentString = `
						<a href="" class="map-links">
						<div>
							<img src="" class="map-thumb" />
							<h4 class="entry-title"></h4>
							<p style="font-size:1.5rem;margin-bottom:0.5rem;">${listingKey}</p>
							<div class="listing-features">
								<div class="listing-feature-sm"> sqft <i class="fa fa-home"></i></div>
								<div class="listing-feature-sm"> <i class="fa fa-bed"></i></div>
								<div class="listing-feature-sm"> <i class="fa fa-bath"></i></div>
							</div>
						</div>
						</a>
					`;

					// create info window
					var infowindow = new google.maps.InfoWindow({
						maxWidth: 375,
						content: '',
					});

					// add to array
					markers.push( marker );

					// show info window when marker is clicked & close other markers
					google.maps.event.addListener(marker, 'click', (function(marker, infowindow, listingKey) {
						return function() {
							// close all the other infowindows that are open
							google.maps.event.trigger(map, 'click');

							infowindow.open( map, marker );
							$.ajax({
								url: 'https://api.bridgedataoutput.com/api/v2/OData/viva/Property(\'' + listingKey + '\')?access_token=5d3573419210dc1f8cdcd42507af245d',
								//contentType: 'application/json',
								success: function( property ) {
									var propertyStreetAddress = property.StreetNumber + ' ' + property.StreetName + ' ' + property.StreetSuffix;
									if ( property.UnitNumber ) {
										var propertyUnitNumber = '#' + property.UnitNumber + ' ';
									} else {
										var propertyUnitNumber = '';
									}
									var propertyTitle = propertyUnitNumber + propertyStreetAddress + '.';
									var addressUrlSlug = propertyUnitNumber + propertyStreetAddress;
									addressUrlSlug = addressUrlSlug.trim().replace(/\s+/g, '-').replace(/\#/g, '').toLowerCase();
									var locationUrlSlug = property.MLSAreaMajor.replace(/\s+/g, '-').toLowerCase();

									var contentProperty = `
									<style>
									.gm-style .gm-style-iw-c {padding:0;}
									.gm-style-iw-d {overflow:hidden !important;}
									</style>
									<a href="/property/${locationUrlSlug}/${addressUrlSlug}-${property.ListingId}/">
									<div>
										<img src="${property.Media[0].MediaURL}" class="map-thumb" style="width:100%;" height="250" />
										<h2 class="entry-title text-2xl" style="padding:8px 15px;margin:0;">${propertyTitle}</h2>
										<h3 class="text-base" style="padding:0 15px;margin:0;">${property.MLSAreaMajor}</h3>
										<div class="listing-features text-black" style="padding:15px;">
											<div class="listing-feature-sm inline text-base">${property.LivingArea} sqft <i class="fa fa-home"></i></div>
											<div class="listing-feature-sm inline text-base">${property.BedroomsTotal} Beds<i class="fa fa-bed"></i></div>
											<div class="listing-feature-sm inline text-base">${property.BathroomsTotalInteger} Baths<i class="fa fa-bath"></i></div>
										</div>
									</div>
									</a>
									`;
									infowindow.setContent(contentProperty);
								}
							});
						}
					})(marker, infowindow, listingKey));

					// close info window when map is clicked
					google.maps.event.addListener(map, 'click', (function(infowindow) {
						return function() {
							infowindow.close();
						}
					})(infowindow));
				}
			}
			// Add a marker clusterer to manage the markers.
			markerCluster = new MarkerClusterer(map, markers, {
				imagePath: '/wp-content/themes/windebank/assets/img/m'
			});
		}
	});

	// add to array
	//map.markers.push( marker );


	// show info window when marker is clicked & close other markers
	// google.maps.event.addListener(marker, 'click', function() {
	// 	infowindow.open(map, marker);
	// });

	// // close info window when map is clicked
	// google.maps.event.addListener(map, 'click', function(event) {
	// 	if (infowindow) {
	// 		infowindow.close();
	// 	}
	// });
}

/*
*  center_map
*
*  This function will center the map, showing all markers attached to this map
*
*  @type	function
*  @date	8/11/2013
*  @since	4.3.0
*
*  @param	map (Google Map object)
*  @return	n/a
*/

function center_map( map ) {

	// vars
	var bounds = new google.maps.LatLngBounds();

	// loop through all markers and create bounds
	$.each( map.markers, function( i, marker ){

		var latlng = new google.maps.LatLng( marker.position.lat(), marker.position.lng() );

		bounds.extend( latlng );

	});

	// only 1 marker?
	if( map.markers.length == 1 )
	{
		// set center of map
	    map.setCenter( bounds.getCenter() );
	    map.setZoom( 9 );
	}
	else
	{
		// fit to bounds
		map.setCenter( bounds.getCenter() );
	   	map.setZoom( 9 ); // Change the zoom value as required
		//map.fitBounds( bounds ); // This is the default setting which I have uncommented to stop the World Map being repeated

	}

}

/*
*  document ready
*
*  This function will render each map when the document is ready (page has loaded)
*
*  @type	function
*  @date	8/11/2013
*  @since	5.0.0
*
*  @param	n/a
*  @return	n/a
*/
// global var
//var map = null;
let map;
let markers = [];
var markerCluster;

$(window).load(function() {
	//$(window).scroll(function() {
		//if ( $(window).scrollTop() + $(window).height() >= $('.acf-map').offset().top ) {
			$('.mls-map').each(function() {
				//if(!$('.acf-map').attr('loaded')) {
					map = new_map( $(this) );
					//$('.acf-map').attr('loaded', true);
				//}
			});
		//}
	//});
});

// var mapDiv = document.getElementsByClassName( 'acf-map' );
// var scrollPosition = 1000;

// function mapFunction() {
// 	if ( window.pageYOffset > scrollPosition ) {
//   		map = new_map( $(mapDiv) );
// 	}
// }

// window.onload = mapFunction;

})(jQuery);
